<script lang="ts">
  import landing from '@/assets/images/landing.png'
  import ServerSelect from '@/components/server-select.svelte'
  import { cn } from '@/lib/utils/cn'

  export let title = ''
  export let subtitle = ''
  export let shouldHideServerSelect = false
  export let contentClass: string | undefined = undefined
  export let subtitleClass: string | undefined = undefined
</script>

<div class="flex h-full flex-col">
  <div class="relative max-h-[396px] min-h-0 flex-1">
    <img src={landing} alt="landing" class="h-full object-cover" />
  </div>
  <div
    class={cn('mt-auto flex flex-col gap-[30px] px-9 pb-[50px]', contentClass)}
  >
    <div class="text-content-primary">
      {#if title}
        <h1 class="break-words font-bold text-headline-md">
          {title}
        </h1>
      {/if}
      {#if subtitle}
        <p class={cn('mt-[5px] text-[14px]', subtitleClass)}>
          {subtitle}
        </p>
      {/if}
      {#if !shouldHideServerSelect}
        <ServerSelect />
      {/if}
    </div>
    <slot />
  </div>
</div>
